import { i18n } from '@shared/i18n';
import { GenericModel } from '@shared/model/generic-model';
import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';

import AddressField from '@shared/fields/address-field';
import EnumeratorField from '@shared/fields/enumerator-field';
import DateTimeField from '@shared/fields/date-time-field';
import IdField from '@shared/fields/id-field';
import StringField from '@shared/fields/string-field';
import ImagesField from '@shared/fields/images-field';
import UrlField from '@shared/fields/url-field';
import BooleanField from '@shared/fields/boolean-field';

import ClubContactPersonsField from './club-contact-persons-field';
import ClubCategoriesField from './club-categories-field';
import ClubKitField from './club-kit-field';

function label(name) {
  return i18n(`entities.teamRegistration.fields.${name}`);
}

const fields = {
  id: new IdField('id', label('id')),
  property: new StringField('property', label('property'), { required: true }),
  subproperty: new StringField('subproperty', label('subproperty'), { required: true }),
  clubLogo: new ImagesField(
    'clubLogo',
    label('clubLogo'),
    id => `teamRegistrations/${id}/clubLogo`,
    {
      required: true,
      max: 1,
    }
  ),
  clubName: new StringField('clubName', label('clubName'), { required: true }),
  clubLegalName: new StringField('clubLegalName', label('clubLegalName'), { required: true }),
  clubType: new EnumeratorField('clubType', label('clubType'), getSharedEnumeratorField('clubType'), { required: true }),
  clubFederation: new EnumeratorField('clubFederation', label('clubFederation'), getSharedEnumeratorField('clubFederation'), { required: true }),
  clubLegalEntityId: new StringField('clubLegalEntityId', label('clubLegalEntityId'), { required: true }),
  clubWebsite: new UrlField('clubWebsite', label('clubWebsite'), {}),
  clubNeedsAccommodation: new BooleanField('clubNeedsAccommodation', label('clubNeedsAccommodation'), { required: true }),
  clubKitHome: new ClubKitField('clubKitHome', label('clubKitHome'), { required: true }),
  clubKitAway: new ClubKitField('clubKitAway', label('clubKitAway'), {}),
  clubAddress: new AddressField('address', label('address'), {}),
  clubContactPersons: new ClubContactPersonsField('clubContactPersons', label('clubContactPersons'), {}),
  clubCategories: new ClubCategoriesField('clubCategories', label('clubCategories'), {}),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  )
};

export class TeamRegistrationModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
